const statusorder = {
  ajuft: 'ממתין לאישור משה"בר',
  ajuftmtum: "ממתין לאישור מרשם",
  ajuftmuebt: 'ממתין לאישור משה"בר',
  bdjseqtfmdj: "הזמנתך בבדיקה",
  mtuafut: "הועבר ללקוח לינק לתשלום",
  mtucgfj: "מרשם שגוי",
  nslhebmmus: "הזמנתך נקלטה",
  cgfte: "הזמנתך נסגרה",
  euejjhcet: "הזמנתך בבדיקה",
  etjghcfkn: "הזמנתך בבדיקה",
  afut: "הועבר ללקוח לינק לתשלום",
  hjfhaklij: "מרשם נקלט",
  ugfj: "29 שגוי",
  hjfhaqtfmdj: "הזמנתך בבדיקה",
  mafutibzfa: 'שולם והועבר להכנה למועד שנבחר ע"י לקוח',
  hjfha: "הזמנתך נקלטה",
  mafutqtfmdj: "הזמנתך הועברה לליקוט",
  mbfhih: "הזמנתך בוטלה",
  uflme: "הזמנתך שולמה",
  ocfte: "סגורה",
};

export default statusorder;
